"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledButtonSubtext = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypes2 = _interopRequireDefault(require("@styled-system/prop-types"));

var _base = _interopRequireDefault(require("../../style/themes/base"));

var _buttonTypes = _interopRequireDefault(require("./button-types.style"));

var _icon = _interopRequireDefault(require("../icon/icon.style"));

var _button = require("./button.config");

var _iconConfig = require("../icon/icon-config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const StyledButton = _styledComponents.default.button`
  ${_styledSystem.space}
  ${({
  disabled,
  noWrap
}) => (0, _styledComponents.css)`
    align-items: center;
    cursor: ${disabled ? "not-allowed" : "pointer"};
    display: inline-flex;
    flex-direction: column;
    flex-flow: wrap;
    border-radius: 0;

    ${noWrap && (0, _styledComponents.css)`
      white-space: nowrap;
    `}
    justify-content: center;
    vertical-align: middle;
    outline-offset: 0;
    ${stylingForType}
  `}

  &&& {
    ${({
  mb,
  theme
}) => (mb || mb === 0) && (0, _styledComponents.css)`
        margin-bottom: ${mb * theme.spacing}px;
      `}
  }

  ${({
  fullWidth
}) => fullWidth && (0, _styledComponents.css)`
      width: 100%;
    `}

  ${({
  iconOnly,
  iconPosition,
  theme
}) => (0, _styledComponents.css)`
    ${_icon.default} {
      margin-left: ${!iconOnly && iconPosition === "after" ? `${theme.spacing}px` : "0px"};
      margin-right: ${!iconOnly && iconPosition === "before" ? `${theme.spacing}px` : "0px"};
      margin-bottom: ${iconOnly ? "1px" : "0px"};
      height: ${additionalIconStyle};
      svg {
        margin-top: 0;
      }
      ${iconOnly && "margin-left: auto; margin-right: auto"}
    }
  `}
`;
const StyledButtonSubtext = _styledComponents.default.span`
  font-size: 14px;
  font-weight: 400;
  display: block;
`;
exports.StyledButtonSubtext = StyledButtonSubtext;

function additionalIconStyle({
  iconType
}) {
  if (iconType === "services") return "6px";
  return "16px";
}

function stylingForIconOnly(size) {
  let dimension = "";

  switch (size) {
    case "small":
      dimension = "32px";
      break;

    case "large":
      dimension = "48px";
      break;

    default:
      dimension = "40px";
  }

  return `
  padding: 0px; 
  width: ${dimension}; 
  min-height: ${dimension}`;
}

function stylingForType({
  iconOnly,
  disabled,
  buttonType,
  theme,
  size,
  destructive
}) {
  return (0, _styledComponents.css)`
    border: 2px solid transparent;
    box-sizing: border-box;
    font-weight: 600;
    text-decoration: none;
    &:focus {
      outline: solid 3px ${theme.colors.focus};
    }

    ${(0, _buttonTypes.default)(theme, disabled, destructive)[buttonType]};

    ${size === "small" && (0, _styledComponents.css)`
      font-size: ${theme.text.size};
      min-height: 32px;
    `}

    ${size === "medium" && (0, _styledComponents.css)`
      font-size: ${theme.text.size};
      min-height: 40px;
    `}
    
    ${size === "large" && (0, _styledComponents.css)`
      font-size: 16px;
      min-height: 48px;
    `}
    ${iconOnly && stylingForIconOnly(size)}
  `;
}

StyledButton.defaultProps = {
  theme: _base.default,
  medium: true,
  buttonType: "secondary"
};
StyledButton.propTypes = {
  /** Styled system spacing props */
  ..._propTypes2.default.space,

  /** Button types for new business themes */
  buttonType: _propTypes.default.oneOf(_button.BUTTON_VARIANTS),

  /** The text the button displays */
  children: _propTypes.default.node.isRequired,

  /** Apply disabled state to the button */
  disabled: _propTypes.default.bool,

  /** Defines an Icon position within the button */
  iconPosition: _propTypes.default.oneOf([..._button.BUTTON_ICON_POSITIONS, ""]),

  /** Defines an Icon type within the button (see Icon for options) */
  iconType: _propTypes.default.oneOf([..._iconConfig.ICONS, ""]),

  /** Assigns a size to the button */
  size: _propTypes.default.oneOf(_button.BUTTON_SIZES),

  /** Second text child, renders under main text, only when size is "large" */
  subtext: _propTypes.default.string
};
var _default = StyledButton;
exports.default = _default;